export default "__VITE_ASSET__eeedf5a9__"